import React from 'react';
import { Checkbox } from '@mui/material';
import { ColorSettings } from '../types/decisions';
import ColorPicker from './application/app-components/ColorPicker';

const MultiColorSelector = ({ colors, onColorChange }: {
    colors: ColorSettings[];
    onColorChange: (index: number, isSelected: boolean, newColor: string) => void;
}) => {
    return (
        <>
            {colors.map((color, index) => {
                return (
                    <div key={color.color}>
                        <ColorPicker
                            color={color.color}
                            setColor={(newColor) => {
                                onColorChange(index, color.isSelected, newColor);
                            }}
                        />
                        <br/>
                        <Checkbox
                            checked={color.isSelected}
                            onChange={(_, checked) => onColorChange(index, checked, color.color)}
                        />
                    </div>
                );
            })}
        </>
    );
};

export default MultiColorSelector;